import type { SVGProps } from 'react'
interface SvgCreditCardProps extends SVGProps<SVGSVGElement> {
  size?: string | number
}

const SvgCreditCard = ({ size = '1em', ...props }: SvgCreditCardProps) => (
  <svg height={size} viewBox="0 0 18 18" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="credit-card_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#credit-card_svg__a)">
      <path d="M16.652 4.554v8.892q0 .709-.498 1.208a1.65 1.65 0 0 1-1.208.498H3.054q-.708 0-1.208-.498a1.65 1.65 0 0 1-.498-1.208V4.554q0-.708.498-1.208a1.65 1.65 0 0 1 1.208-.498h11.892q.709 0 1.208.498.498.5.498 1.208M3.054 5.987h11.892V4.554H3.054zm0 3v4.46h11.892v-4.46z" />
    </g>
  </svg>
)
export default SvgCreditCard
